<div class="modal-header">
    <span class="modal-title">{{title || 'Delete'}}</span>
</div>

<div class="modal-footer">
    <button id="refresh-session"
    appTrackClickButton
    type="button"
    class="button primary"
    (click)="refreshPage()">{{applyText}}</button>
</div>
